/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_StartingInputs */



/**
* | output |
* | --- |
* | "Starting loudness analysis (first pass)..." |
*
* @param {Audio_Description_Export_Loudness_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_starting = /** @type {((inputs?: Audio_Description_Export_Loudness_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage de l'analyse de loudness (premier passage)...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautheitsanalyse starten (erster Durchgang)...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio dell'analisi del volume (primo passaggio)...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начальный анализ громкости (первый этап)...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando el análisis de sonoridad (primer paso)...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("初始响度分析（第一遍）……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ラウドネス分析 (第 1 パス) を開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ध्वनि विश्लेषण शुरू करना (पहला चरण)...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a análise de sonoridade (primeira passagem)...")
	return /** @type {LocalizedString} */ ("Starting loudness analysis (first pass)...")
});